export enum WebSocketNotificationTypeEnum {
  Action = 'ws.action',
  MessageError = 'ws.message-error',
  Task = 'ws.task',
  AsyncRequest = 'ws.user.async-request',
  AccesCheck = 'ws.user.status-check',
  ExternalUserCrm = 'ws.external-user',
  AppleMessagesCloseConversation = 'ws.external-user.bzc-close',
  AIAssistantSuggestion = 'ws.ai.suggest-answer',
  AIAssistantSummary = 'ws.ai.summary',
  EngagementCRMTask = 'ws.engagement.crm.task',
}
